import { links as allLinks } from 'bzx-common/src/config/appConfig'
import { routes } from 'bzx-common/src/config/appConfig'

function showIntercom(event: any) {
  event.preventDefault()
  // @ts-ignore
  if (window.Intercom) {
    // @ts-ignore
    window.Intercom('show')
  }
}

export const linksSocials = Object.values(allLinks.socials)

export const linksMore = [
  { title: 'Stats', icon: 'Stats', link: '/stats', external: false },
  { title: 'Tools', icon: 'tools', link: '/tools', external: false },
  { title: 'Dao Snapshot', icon: 'DAO', link: allLinks.daoSnapshot, external: true },
  { title: 'Blog', icon: 'Blog', link: allLinks.blog.url, external: true },
  { title: 'Shop', icon: 'Shop', link: allLinks.shop, external: true },
  { title: 'NFT', icon: 'NFT', link: '/dashboard/nfts', external: false },
  { title: 'FAQ', icon: 'FAQ', link: allLinks.gitbook, external: true },
  { title: 'Help Chat', icon: 'HelpChat', link: '/chat', onClick: showIntercom, external: true },
]

export const featuresLinks = [
  { title: 'Dashboard', icon: 'Dashboard', link: '/dashboard', external: false },
  { title: 'Trade', icon: 'Trade', link: routes.tradeChart, external: false },
  { title: 'Lend', icon: 'Lend', link: '/lend', external: false },
  { title: 'Borrow', icon: 'Borrow', link: '/borrow', external: false },
  { title: 'Stake', icon: 'Stake', link: '/stake', external: false },
]

export const linksHelp = [
  { title: 'FAQ', icon: 'FAQ', link: allLinks.gitbook, external: true },
  { title: 'Chat With Us', icon: 'HelpChat', link: '/chat', onClick: showIntercom, external: true },
]

export default {
  linksSocials,
  linksMore,
  featuresLinks,
}
